var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObservations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199.1 199.1",
    style: {
      enableBackground: "new 0 0 199.1 199.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008EC1;}\n\t.st1{fill:#9CCDE2;}\n\t.st2{fill:#C1E4EF;}\n\t.st3{fill:#F3E491;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#CCB866;}\n\t.st6{fill:#1A2730;}\n\t.st7{fill:#263644;}\n\t.st8{fill:#374A5E;}\n\t.st9{fill:#677684;}\n\t.st10{fill:#99CCE2;}\n\t.st11{fill:#5DB18B;}\n\t.st12{fill:#E6E7E8;}\n\t.st13{fill:#A12646;}\n\t.st14{clip-path:url(#SVGID_2_);}\n\t.st15{fill:#E6AE52;}\n\t.st16{clip-path:url(#SVGID_4_);}\n\t.st17{fill:#33495E;}\n\t.st18{fill:#3498D4;}\n\t.st19{fill:#278AC7;}\n\t.st20{fill:#58B28A;}\n\t.st21{fill:#E2DBBF;}\n\t.st22{fill:#F2F0E7;}\n\t.st23{fill:none;}\n\t.st24{fill:#FFEEA9;}\n\t.st25{fill:#D3D3D3;}\n\t.st26{fill:#D7F1F7;}\n\t.st27{fill:#E8D99E;}\n\t.st28{fill:#EFEFEF;}\n\t.st29{fill:#F4E39A;}\n\t.st30{fill:#7F1D3C;}\n\t.st31{fill:#4A9672;}\n\t.st32{clip-path:url(#SVGID_8_);}\n\t.st33{clip-path:url(#SVGID_14_);}\n\t.st34{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st35{fill:#C1272D;}\n\t.st36{fill:none;stroke:#E6AE52;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 99.5,
    cy: 99.5,
    r: 99.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.2,47c13.6,0,26.4,3,37.9,8.5c-15.4-27-44.3-45.1-77.6-45.1c-49.3,0-89.3,40-89.3,89.3 c0,35.7,21,66.5,51.3,80.8c-7.4-13-11.7-28.1-11.7-44.1C49.9,86.9,89.9,47,139.2,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.8,99.5c0-16.1-4.3-31.1-11.7-44.1C165.6,50,152.7,47,139.2,47c-49.3,0-89.3,40-89.3,89.3 c0,16.1,4.3,31.1,11.7,44.1c11.5,5.4,24.4,8.5,37.9,8.5C148.8,188.8,188.8,148.8,188.8,99.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62.8,
    y: 37.5,
    transform: "matrix(0.9996 -2.965453e-02 2.965453e-02 0.9996 -2.5473 3.1612)",
    className: "st28",
    width: 85,
    height: 100
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.7,
    y: 40.6,
    transform: "matrix(0.9918 -0.1279 0.1279 0.9918 -10.774 13.4297)",
    className: "st4",
    width: 85,
    height: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 48.9,
    y: 52.8,
    transform: "matrix(0.9458 -0.3247 0.3247 0.9458 -28.4364 35.2457)",
    className: "st8",
    width: 85,
    height: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 49.2,
    y: 69.4,
    transform: "matrix(0.9458 -0.3247 0.3247 0.9458 -22.3162 23.136)",
    className: "st3",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.5,
    y: 90.8,
    transform: "matrix(0.9458 -0.3247 0.3247 0.9458 -28.8514 26.6731)",
    className: "st15",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8,
    y: 112.1,
    transform: "matrix(0.9458 -0.3247 0.3247 0.9458 -35.3866 30.2102)",
    className: "st11",
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.8,
    y: 125.5,
    transform: "matrix(0.9458 -0.3247 0.3247 0.9458 -38.063 40.8769)",
    className: "st4",
    width: 67.2,
    height: 18
  })), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 56.2,
    transform: "matrix(0.9458 -0.3247 0.3247 0.9458 -23.0821 37.2143)",
    className: "st18",
    width: 43,
    height: 63.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M29.4,85c-0.3-0.8,0.3-1.8,1.4-2.1l11-3.8c1-0.4,2.1,0,2.4,0.8c0.3,0.8-0.3,1.8-1.4,2.1l-11,3.8 C30.8,86.2,29.7,85.8,29.4,85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M33.4,96.7c-0.3-0.8,0.3-1.8,1.4-2.1l11-3.8c1-0.4,2.1,0,2.4,0.8c0.3,0.8-0.3,1.8-1.4,2.1l-11,3.8 C34.8,97.9,33.7,97.5,33.4,96.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M37.4,108.3c-0.3-0.8,0.3-1.8,1.4-2.1l11-3.8c1-0.4,2.1,0,2.4,0.8c0.3,0.8-0.3,1.8-1.4,2.1l-11,3.8 C38.8,109.5,37.7,109.1,37.4,108.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M41.5,120c-0.3-0.8,0.3-1.8,1.4-2.1l11-3.8c1-0.4,2.1,0,2.4,0.8c0.3,0.8-0.3,1.8-1.4,2.1l-11,3.8 C42.8,121.2,41.8,120.8,41.5,120z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M45.5,131.7c-0.3-0.8,0.3-1.8,1.4-2.1l11-3.8c1-0.4,2.1,0,2.4,0.8c0.3,0.8-0.3,1.8-1.4,2.1l-11,3.8 C46.9,132.8,45.8,132.5,45.5,131.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M49.6,143.3c-0.3-0.8,0.3-1.8,1.4-2.1l11-3.8c1-0.4,2.1,0,2.4,0.8c0.3,0.8-0.3,1.8-1.4,2.1l-11,3.8 C50.9,144.5,49.8,144.2,49.6,143.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M53.6,154.9c-0.3-0.8,0.3-1.8,1.4-2.1l11-3.8c1-0.4,2.1,0,2.4,0.8c0.3,0.8-0.3,1.8-1.4,2.1l-11,3.8 C54.9,156.1,53.9,155.8,53.6,154.9z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObservations);
export default __webpack_public_path__ + "static/media/observations.72173c56dd61c5dc94365da02becf343.svg";
export { ForwardRef as ReactComponent };